import React from 'react';
import PropTypes from 'prop-types';

const AlbumsMessage = ({ uploadedToAlbumPath, className }) => {
  return (
    <p
      className={`uploaded-to-album ${className || ''}`.trim()}
      data-test-id="uploaded-to-album">
      For your convenience, all photos uploaded are also saved to &lsquo;
      <a href={uploadedToAlbumPath} data-test-id="uploaded-to-album-link">
        My Photos
      </a>
      &rsquo;
    </p>
  );
};

AlbumsMessage.propTypes = {
  uploadedToAlbumPath: PropTypes.string.isRequired,
  className: PropTypes.string,
};

AlbumsMessage.defaultProps = {
  className: null,
};

export { AlbumsMessage };
